import { updateItems } from '@/mocks/homeData';

const categoryColors: Record<string, string> = {
  '新片上线': 'bg-primary-100 text-primary-700',
  '内容更新': 'bg-accent-100 text-accent-700',
  '功能升级': 'bg-secondary-100 text-secondary-800',
  '项目启动': 'bg-accent-100 text-accent-700',
  '合作动态': 'bg-primary-100 text-primary-700',
  '产品动态': 'bg-secondary-100 text-secondary-800',
  '里程碑': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">最新动态</h2>
            <p className="text-sm text-foreground-500 mt-2">平台最新资讯与更新公告</p>
          </div>
          <a href="#" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            全部动态 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>
            <div className="space-y-5">
              {updateItems.map((item) => (
                <div key={item.id} className="flex items-start gap-5 relative">
                  <div className="shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center z-10">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                  <div className="flex-1 min-w-0 pb-1">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${categoryColors[item.category] || 'bg-foreground-100 text-foreground-600'}`}>{item.category}</span>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-800 mt-1.5 leading-relaxed">{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}